¸<template>
    <div class="col _historystatus __wrapper_">
        <div class="col __historycontent"
            v-if="isLoading">
            <half-circle-spinner
                :animation-duration="750"
                :size="100"
                color="#1D3354"
                class="mx-auto"
                />
        </div>
        <div
            v-else-if="detail">
            <div class="col __historycontent">
                <div class="row __headercontent">
                    <div class=" col-7 align-items-center __background_navy __header-left">
                        <div>
                            <p class="__contracttype">{{ getType(detail.statusShipment) }}</p>
                            <p class="__route">{{ detail.originCity }} [{{ detail.originCountryCode }}] to {{ detail.destinationCity }} [{{ detail.destinationCountryCode}}] </p>
                        </div>
                    </div>
                    <div class="col-5  align-items-center __background_navy  __header-right">
                        <div>
                            <p class="__status"> Completed </p>
                            <div class="row">
                                <p class="__titledate">Payment Completion Date</p>
                                <p class="__date">: {{ getDateCompleted(detail.updatedAt) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col __bodycontent">
                <p class="__titledetails">Shipments Details</p>
                <br>
                <div class="row __detailsbody">
                        <div class="col-2 p-0 __categoryleft">
                            <p>User Initial ID</p>
                            <p>Company Name</p>
                            <p>Order Number</p>
                            <p><br/></p>
                            <p v-if="parseInt(detail.statusShipment) !== 0">{{ getType(detail.statusShipment) }} Number</p>
                            <br>
                            <p>Shipment Mode</p>
                            <p>Shipment Type</p>
                            <p>Shipment Route</p>
                            <p v-if="parseInt(detail.statusShipment) === 2">Contract Duration</p>
                            <!-- <p v-else>Estimate Duration</p> -->
                            <p v-if="parseInt(detail.statusShipment) !== 0">Ideal Budget</p>
                            <p>Term of Payment</p>
                        </div>
                        <div class="col-5 p-0 __detailsleft">
                            <p>: {{ detail.custInisial }}</p>
                            <p>: {{ detail.bookType === 'export' ? detail.shipperCompany : detail.consigneeCompany }}</p>
                            <p>: {{ detail.orderNumber.substr(0,36) }} <br/> {{ detail.orderNumber.substr(36,48) }} </p>
                            <p v-if="parseInt(detail.statusShipment) !== 0">: {{ detail.referenceNumber }}</p>
                            <br>
                            <p>: {{ detail.freightMode }}</p>
                            <p>: {{ detail.freightType }}</p>
                            <p>: Port to Port</p>
                            <p v-if="parseInt(detail.statusShipment) === 2">: {{ detail.durationStart && getDate(detail.durationStart) }} - {{ detail.durationEnd && getDate(detail.durationEnd) }}</p>
                            <!-- <p v-else>: 5 - 10 Days</p> -->
                            <p v-if="parseInt(detail.statusShipment) === 1">:
                              IDR {{ detail.rfqRateFrom ? detail.rfqRateFrom.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }} -
                              IDR {{ detail.rfqRateTo ? detail.rfqRateTo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}
                            </p>
                            <p v-else-if="parseInt(detail.statusShipment) === 2">:
                              IDR {{ detail.contractRateFrom ? detail.contractRateFrom.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }} -
                              IDR {{ detail.contractRateTo ? detail.contractRateTo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}
                            </p>
                            <p>: {{ detail.termOfPayment }} days</p>
                        </div>
                        <div class="col">
                            <div class="row p-0">
                                <div class="col p-0 __categoryright">
                                    <p>Estimate Value of Goods</p>
                                    <p>HS Code</p>
                                    <p>Product Type</p>
                                    <p>Product Description</p>
                                    <p v-if="form.type == 'Contract'">Estimate Volume/Month</p>
                                    <p v-if="form.type == 'Contract'">Estimate Weight/Month</p>
                                    <p>Additional Services</p>
                                </div>
                                <div class="col p-0 __detailsright">
                                    <p>: IDR {{ detail.valueOfGoods > 0 ? detail.valueOfGoods.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : detail.valueOfGoods }}</p>
                                    <p>: {{ detail.commoditiesHSCode }}</p>
                                    <p>: {{ detail.commoditiesClass }}</p>
                                    <p>: {{ detail.commoditiesProduct }}</p>
                                    <p v-if="parseInt(detail.statusShipment) === 1">: 100 CBM</p>
                                    <p v-if="parseInt(detail.statusShipment) === 1">: 100 Kg</p>
                                    <p>: {{ parseInt(detail.insuranceStat) === 0 ? '' : 'Insurance' }} {{ parseInt(detail.customStat) === 0 ? '' : ', Custom Clearance (Origin)' }} {{ detail.custom_destination_stat ? ', Custom Clearance (Destination)' : '' }}</p>
                                </div>
                            </div>
                            <div class="row __merchantnotes">
                                <div class="col p-0 ">
                                    <p>Notes for Merchant</p>
                                </div>
                                <div class="col">
                                    <p>: {{ detail.shipperNotes ? detail.shipperNotes : '-' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="(parseInt(detail.isInvoiceIssued) === 1 && detail.invoiceNumber)">
                <div class="text-right __download" @click="downloadInvoice(null)">
                    <img src="@/assets/image/icon/download-invoice.svg" alt="">
                    <u>Download Invoice</u>
                </div>
            </div>
            <div
                v-for="(item, index) in invoiceList"
                v-bind:key="item.id">
                <div class="text-right __download" @click="downloadInvoice(item.id)">
                    <img src="@/assets/image/icon/download-invoice.svg" alt="">
                    <u>Download Invoice {{ index+1 }}</u>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'
import * as moment from 'moment'

export default {
  name: 'HistoryStatus',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      form: {},
      params: {
        shipmentId: this.$route.params.shipmentId,
        orderNumber: this.$route.params.orderNumber
      }
    }
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error'
    }),
    ...mapGetters({
      invoiceList: 'shipment/invoices',
      isLoadingInvoice: 'shipment/isLoadingInvoice',
      isErrorInvoice: 'shipment/errorInvoice'
    })
  },
  mounted () {
    this.fetchInvoice()
  },
  methods: {
    fetchInvoice () {
      const shipmentId = this.shipmentId
      this.$store.dispatch('shipment/FETCH_SHIPMENT_INVOICE', shipmentId)
    },
    getOptionTp (type) {
      let optionTp = '-'
      switch (type) {
        case 'ptp' : optionTp = 'Port to Port'
          break
        case 'dtp' : optionTp = 'Door to Port'
          break
        case 'dtd' : optionTp = 'Door to Door'
          break
        case 'ptd' : optionTp = 'Port to Door'
          break
        default : optionTp = '-'
        /* eslint-disable-next-line */
      }
      /* eslint-disable-next-line */
      return optionTp
      /* eslint-disable-next-line */
    },
    getDate (date) {
      return moment(date).format('DD/MM/YY')
    },
    getDateCompleted (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getType (statusShipment) {
      let type = ''
      switch (statusShipment) {
        case 0 :
          type = 'Instant Price'
          break
        case 1 :
          type = 'RFQ'
          break
        case 2 :
          type = 'Contract'
          break
        default :
          type = ''
      }
      return type
    },
    downloadInvoice (invoiceId) {
      const shipmentId = this.params.shipmentId
      const orderNumber = this.params.orderNumber
      const fileName = `INV_${orderNumber}.pdf`
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_INVOICE', {shipmentId, orderNumber, invoiceId, fileName})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment/paymentStatus/HistoryStatus.vue